export default "__VITE_ASSET__BIA6wuXh__"